import React from "react";
import facebook from "../../assets/icon/facebook.svg";
import instagram from "../../assets/icon/instagram.svg";
import twitterx from "../../assets/icon/twitterx.svg";
import youtube from "../../assets/icon/youtube.svg";
import logo from "../../assets/logo.png";
import AmericaExpress from "../../assets/icon/payment/americaexpress.svg";
import Discover from "../../assets/icon/payment/discover.svg";
import MasterCard from "../../assets/icon/payment/mastercard.svg";
import Paypal from "../../assets/icon/payment/paypal.svg";
import Stripe from "../../assets/icon/payment/stripe.svg";
import ApplePay from "../../assets/icon/payment/applepay.svg";
import SamsungPay from "../../assets/icon/payment/samsungpay.svg";
import Visa from "../../assets/icon/payment/visa.svg";
import Tabby from "../../assets/icon/payment/tabby.svg";
import DinnerClub from "../../assets/icon/payment/dinnerclub.svg";
import IATA from "../../assets/iata.svg";

function index() {
  return (
    <div>
      <footer className="pt-10 pb-4 px-5 md:px-8 lg:px-15">
        <div className="divide-y divide-[#100A55]">
          <div className="flex flex-col justify-center items-center lg:items-start lg:flex-row lg:justify-between">
            <div className="flex flex-col justify-center gap-2">
              <a href="/">
                {" "}
                <img
                  src={logo}
                  alt="fbt-b2b"
                  className="w-full mt-2 max-w-48 md:w-48"
                />
              </a>
              <div className="font-normal text-2xl font primary flex gap-2 pb-5 justify-center items-center">
                <a href="https://www.facebook.com/fbtadventuresuae/" target="_blank" rel="noreferrer">
                  <img src={facebook} className="w-10" alt="facebook" />
                </a>
                <a href="https://www.instagram.com/fbtadventures/" target="_blank" rel="noreferrer">
                  <img src={instagram} className="w-10" alt="instagram" />
                </a>
                <a href="https://x.com/FbtAdventures">
                  <img src={twitterx} className="w-10" alt="twitterX" target="_blank" rel="noreferrer"/>
                </a>
                <a href="https://www.youtube.com/@fbtadventures/">
                  <img src={youtube} className="w-10" alt="youtube" target="_blank" rel="noreferrer"/>
                </a>
              </div>
            </div>

            <div className="text-center flex flex-col gap-2">
              <h1 className="font-bold text-2xl font-primary my-5 md:mt-0">
                Quick Links
              </h1>
              <div className="font-bold text-base font-primary flex gap-5 justify-center items-center mb-5 flex-col md:flex-row">
                <a href="/aboutus">About us</a>
                <a href="/ourproducts">Our Products</a>
                <a href="/contactus">Contact Us</a>
                <a href="/privacypolicy">Privacy Policy</a>
                <a href="/terms&condition">Terms & Condition</a>
              </div>
              <div className="flex flex-row justify-center gap-1 pb-10 items-center">
                <div className="font-bold">Associate by </div>
                <img src={IATA} alt="fbtb2b" />
              </div>
            </div>

            <div className="font-normal flex-col text-2xl font primary flex gap-2 justify-center items-center">
              <h1 className="font-bold text-2xl font-primary md:mt-0">
                We Offer
              </h1>
              <div className="flex gap-4">
                <img
                  src={AmericaExpress}
                  className="w-10"
                  alt="AmericaExpress"
                />

                <img src={Discover} className="w-10" alt="Discover" />

                <img src={MasterCard} className="w-10" alt="facebook" />

                <img src={Paypal} className="w-10" alt="facebook" />

                <img src={Stripe} className="w-10" alt="facebook" />
              </div>
              <div className="flex gap-4">
                <img src={ApplePay} className="w-10" alt="AmericaExpress" />

                <img src={SamsungPay} className="w-10" alt="Discover" />

                <img src={Visa} className="w-10" alt="facebook" />

                <img src={Tabby} className="w-10" alt="facebook" />

                <img src={DinnerClub} className="w-10" alt="facebook" />
              </div>
            </div>
          </div>

          <div className="flex flex-col text-center justify-between pt-5 md:flex-row">
            <a href="/" className="font-semibold font-primary text-base">
              Copyright @ 2024 FBT Adventures.
            </a>
            <div className="flex justify-center items-center">
              <a
                href="http://techaag.com/"
                target="_blank"
                className="font-semibold font-primary text-base"
                rel="noreferrer"
              >
                Designed & Developed by TechAAG
              </a>
              <i className="ri-heart-3-line text-lg font-extrabold text-red-600"></i>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default index;
